import { apiClient } from "../lib/api";

export const actionCenterApi = {
  getDigest: (filters) => apiClient.get("/action-center/digest", { params: filters }),
  getDigestPdfUrl: () => `${apiClient.defaults.baseURL}/action-center/digest/pdf`,
};
